import { render, staticRenderFns } from "./InsuranceCertificateForm.vue?vue&type=template&id=ca70d3a6&scoped=true"
import script from "./InsuranceCertificateForm.vue?vue&type=script&lang=js"
export * from "./InsuranceCertificateForm.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCertificateForm.vue?vue&type=style&index=0&id=ca70d3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca70d3a6",
  null
  
)

export default component.exports